import './RecommendedPlayer.css';

const RecommendedPlayer = ({
  player,
  ev,
  isLoading,
  isExpanded,
  currentTeam,
  picksUntilNext,
  futureProjected,
  positionEVs,
  onToggleExpand,
  onQuickDraft,
  getPositionDisplay,
  getBestAvailableForPosition
}) => {
  if (!player) {
    return isLoading ? (
      <div className="recommended-player recommended-computing">
        Calculating recommendation…
      </div>
    ) : null;
  }

  return (
    <div
      className="recommended-player"
      data-expanded={isExpanded}
      onClick={(e) => {
        if (!e.target.closest('.expander-button')) {
          onQuickDraft(player);
        }
      }}
    >
      <div className="recommended-details">
        <button
          className={`expander-button ${isExpanded ? 'expanded' : ''}`}
          onClick={(e) => {
            e.stopPropagation();
            onToggleExpand();
          }}
        >
          ▼
        </button>
        <span className="player-name">{player.name}</span>
        <span className="player-position">{getPositionDisplay(player, 'BENCH')}</span>
        <span className="player-team">{player.team}</span>
        <span className="player-projected">{player.projected.toFixed(1)}</span>
        <span className="player-ev">EV: {ev.toFixed(1)}</span>
        {isLoading && <span className="recommended-updating">updating…</span>}
        <span className="current-team">Team {currentTeam + 1}</span>
      </div>
      {isExpanded && (
        <>
          <div className="future-pick-details">
            <span>Next pick in {picksUntilNext} picks</span>
            <span>Future value: {futureProjected.toFixed(1)}</span>
          </div>
          <div className="position-evs">
            {Object.entries(positionEVs)
              .sort((a, b) => b[1].ev - a[1].ev)
              .map(([pos, data]) => {
                const bestPlayer = getBestAvailableForPosition(pos);
                return (
                  <div key={pos} className="position-ev-row">
                    <span className="position">{pos}</span>
                    <span className="values">
                      <span
                        className="best-player-name"
                        onClick={(e) => {
                          e.stopPropagation();
                          onQuickDraft(bestPlayer);
                        }}
                      >
                        {bestPlayer?.name}
                      </span>
                      {" → "}{data.future.toFixed(1)}
                    </span>
                    <span className="ev">EV: {data.ev.toFixed(1)}</span>
                    <span className="picks">({data.picks} picks)</span>
                  </div>
                );
              })}
          </div>
        </>
      )}
    </div>
  );
};

export default RecommendedPlayer;
